import { render, staticRenderFns } from "./SecondQuestion.vue?vue&type=template&id=5419a931&"
import script from "./SecondQuestion.vue?vue&type=script&lang=js&"
export * from "./SecondQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5419a931')) {
      api.createRecord('5419a931', component.options)
    } else {
      api.reload('5419a931', component.options)
    }
    module.hot.accept("./SecondQuestion.vue?vue&type=template&id=5419a931&", function () {
      api.rerender('5419a931', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/domains/TranferFAQ/SecondQuestion.vue"
export default component.exports